import { addDays, addHours, startOfDay } from 'date-fns';

export const getDayPlusOffsetHours = (date: Date, hours: number) => addHours(date, hours);

export const getDayPlusOffsetHoursOnOpenHours = (
  date: Date,
  hours: number,
  openHour: number,
  closeHour: number
) => {
  const datePlusOffsetHours = getDayPlusOffsetHours(date, hours);
  const datePlusOffsetHoursHour = datePlusOffsetHours.getHours();

  if (datePlusOffsetHoursHour >= closeHour) {
    return addHours(addDays(startOfDay(datePlusOffsetHours), 1), openHour);
  }

  if (datePlusOffsetHoursHour < openHour) {
    return addHours(startOfDay(datePlusOffsetHours), openHour);
  }

  return datePlusOffsetHours;
};

export const getNinetyDays = (date: Date) => {
  return addDays(date, 89);
};
